export default __webpack_public_path__ + "static/google reviews-9406e4583e7fd23e9f72e6b47dbab963.svg";